/* eslint-disable react/destructuring-assignment */
import React, { SVGProps } from 'react';

function ArrowUpIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M12 9.13003L4.47 16.66C4.27 16.86 4.03 16.96 3.76 16.95C3.49 16.95 3.25 16.84 3.05 16.64C2.85 16.44 2.75 16.2 2.75 15.93C2.75 15.66 2.85 15.42 3.05 15.22L10.72 7.56003C10.9 7.38003 11.1 7.25003 11.33 7.16003C11.55 7.07003 11.78 7.03003 12 7.03003C12.22 7.03003 12.45 7.07003 12.67 7.16003C12.89 7.25003 13.1 7.38003 13.28 7.56003L20.95 15.23C21.15 15.43 21.25 15.66 21.24 15.93C21.24 16.2 21.13 16.43 20.93 16.63C20.73 16.83 20.49 16.93 20.22 16.93C19.95 16.93 19.71 16.83 19.51 16.63L11.99 9.11003L12 9.13003Z" fill="currentColor" />
    </svg>
  );
}

export default ArrowUpIcon;
